import Util from '@/helper/Utility.js';

export function RegisterModel () {
    this.id_token = null;
    this.contact_number = null;
    this.name = null;
    this.surname = null;
    this.email = null;
    this.otp = null;
    this.refcode = null;
    this.refusercode = null;
    this.birthdate = null;
    this.shopinfo = null;

    this.marketingOption = 0;
    this.marketing = {
        email: 0,
        line: 0,
        notification: 0,
        sms: 0,
    };
    this.termandcondition = 1;
    this.dataprivacy = 1;
    this.setRefUserCode = function(userCode){
        this.refusercode = userCode
    }
    this.setModel = function (register, otp, pdpaConsent) {
        console.log('register', register);
        console.log('pdpaConsent', pdpaConsent);
        
        this.contact_number = otp.contact_number;
        this.otp = otp.otp;
        this.refcode = otp.refcode;
        this.name = register.name;
        this.surname = register.lastname;
        this.email = register.email;
        this.birthdate = register.birthdate;

        this.shopinfo = JSON.stringify(register.shopinfo);
        this.marketingOption = pdpaConsent.marketingOption;
        this.marketing.email = pdpaConsent.email;
        this.marketing.sms = pdpaConsent.sms;
        this.marketing.notification = pdpaConsent.notification;
        this.marketing.line = pdpaConsent.line;
        this.termandcondition = pdpaConsent.terms;
        this.dataprivacy = pdpaConsent.privacy;
    };

    this.getParams = function() {
        var params = {
            id_token: this.id_token,
            contact_number: this.contact_number,
            name: this.name,
            surname: this.surname,
            email: this.email,
            otp: this.otp,
            refcode: this.refcode,
            refusercode: this.refusercode,
            birthdate: this.birthdate,
            shopinfo: this.shopinfo,
            marketingOption: this.marketingOption,
            // marketing: this.marketing,
            mktoption_sms: this.marketing.sms,
            mktoption_email: this.marketing.email,
            mktoption_line: this.marketing.line,
            termandcondition: this.termandcondition,
            dataprivacy: this.dataprivacy

        };

        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}
